<template>
  <div id="ChangeDeviceModal">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title" style="color: whitesmoke;">機器変更</p>
      </header>
      <section class="modal-card-body" style="width:100%;text-align:left;">
        <tr>
          <th style="width:30%;vertical-align:middle;">機器種別：</th>
          <td>{{model | getNameFilter(modelList) }}</td>
        </tr>
        <tr>
          <th style="width:30%;vertical-align:middle;">変更前シリアル：</th>
          <td>
            <b-input id="oldSerialNumber" v-model="oldSerialNumber" readonly></b-input>
          </td>
        </tr>
        <tr>
          <th style="width:30%;vertical-align:middle;">変更後シリアル：</th>
          <td>
            <b-input id="newSerial" v-model="newSerial" @keyup.enter.native="onKeyupEnter()"></b-input>
          </td>
        </tr>
      </section>
      <footer class="modal-card-foot">
        <div style="margin:auto;">
          <b-button label="OK" @click="doSave"/>
          <b-button label="閉じる" @click="$parent.close()" />
        </div>
      </footer>
      <b-modal
        :active.sync="finalConfirmationModalActive"
        has-modal-card
        trap-focus
        :destroy-on-hide="false"
        aria-role="dialog"
        aria-label="Example Modal"
        aria-modal>
        <div class="modal-card" style="width: 650px;">
            <header class="modal-card-head" style="height:70px;">
                <p class="modal-card-title"></p>
            </header>
            <section class="modal-card-body">
                <table class="modalTable">
                    <tr><td style="padding-left:10%;font-size:20px;">機器を変更します。よろしいですか？</td></tr>
                    <tr>
                    <tr><td style="padding-left:10%;font-size:20px;">変更前の機器は状態が「利用可能」に戻ります。</td></tr>
                </table>
            </section>
            <footer class="modal-card-foot">
              <div style="margin:auto;">
                <b-button label="OK" @click="save"/>
                <b-button label="キャンセル" @click="finalConfirmationModalActive=false" />
              </div>
            </footer>
        </div>
    </b-modal>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChangeDeviceModal",
  props:["oldSerialNumber","model","choicesType","receptionNo","type"],
  methods: {
    onKeyupEnter: function(){
      if(!this.newSerial){
        return
      }
      //シリアルを取得
      let serialItems = this.newSerial.split('/');
      if(serialItems.length == 2){
        //　"/"が含まれていたらそれ以降の文字に変更する
        this.newSerial = serialItems[1]
      }
      // フォーカスを外す
      let element = document.getElementById("newSerial");
      element.blur();
    },
    doSave: function() {
      if(!this.newSerial){
        this.showErrorMessage("シリアルが入力されていません。");
        return
      }
      var _this = this;
      this.apiCall(
          function(client){
            return client.apis.apiCommon.getMachineDetailPOST({
              body: {
                serial:_this.newSerial,
                modelId:_this.model
              }
            });
          },
          function(result){
            var machineDetail = result.obj;
            if(_this.isPastday(machineDetail.leaseupDate)){
              // リースアップ日を超えている場合は、警告メッセージ
              var messsge = machineDetail.leaseupDate + "にリースアップ日を超過している機器です。";
              _this.$dialog.alert({title: '　',message: messsge,})
              _this.newSerial = ""
            }else if(_this.isSoon(machineDetail.leaseupDate,2)){
              // リースアップ日が2ヶ月以内の場合近づいている場合は、警告メッセージ
              var messsge = machineDetail.leaseupDate + "にリースアップする機器です。";
              _this.$dialog.alert({title: '　',message: messsge,})
              _this.newSerial = ""
            }else{
              _this.finalConfirmationModalActive=true
            }
          },
          function(result){
            _this.showErrorMessage(result);
            _this.newSerial = ""
          }
        );
    },
    save: function() {
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.apiCommon.setChangeSerialPOST({
            body: {
              oldSerial:_this.oldSerialNumber,
              newSerial:_this.newSerial,
              modelId:_this.model,
              receptionNo:_this.receptionNo,
              type:_this.type
            }
          });
        },
        function(result){
          _this.$emit('save', _this.newSerial);
          _this.$parent.close();
        },
        function(result){
          _this.showErrorMessage(result);
        }
      );
    }
  },
  data() {
    var modelList = this.getChoiceList(this.choicesType, false);
    return {
      newSerial:"",
      modelList,
      finalConfirmationModalActive:false
    };
  },
  filters: {
    getNameFilter: function(val, list){
      var target = list.find(item => item.value == val)
      if(target){
        return target.label1
      }
      return ""
    }
  },
  components: {},
  mounted: function () {},
};
</script>
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/common/ChangeDeviceModal.vue